const uberV2 = {
  voucherDueDateTitle: 'วันครบกำหนด',
};

module.exports = uberV2;
